import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectsBreadcrumb: {
		id: 'servicedesk-reports-common.header.projects-breadcrumb',
		defaultMessage: 'Projects',
		description: 'Title of the breadcrumb that navigates to the projects page',
	},
	reportsBreadcrumb: {
		id: 'servicedesk-reports-common.header.reports-breadcrumb',
		defaultMessage: 'Reports',
		description: 'Title of the breadcrumb that navigates to the reports page',
	},
});
